export default "__VITE_PUBLIC_ASSET__745ba17b__"